import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-map-direction1-icon',
  templateUrl: './map-direction1.component.html'
})
export class MapDirection1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
